import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./PersonalDetails.css";
import { Link } from "react-router-dom";
import { baseUrl, formatDateToDDMMYYYY } from "../../../Utility/constants";
import { useRef } from "react";
import { getSchoolId } from "../../../Utility/commonFunctions";
import axios from "axios";

const StudentDetailsModal = ({ show, handleDetailsClose, studentDetails }) => {
  const [photoBase64, setPhotoBase64] = useState("");
  const [schoolId, setSchoolId] = useState(null);
  const [schoolData, setSchoolData] = useState([]);

  useEffect(() => {
    const convert = async () => {
      if (studentDetails?.studentPhoto) {
        console.log("Fetching photo:", studentDetails.studentPhoto);
        const photoUrl = encodeURI(studentDetails.studentPhoto);
        const base64 = await toBase64Image(photoUrl);

        console.log("Fetched Base64:", base64?.substring(0, 50));
        setPhotoBase64(base64);
      }
    };
    convert();
  }, [studentDetails?.studentPhoto]);

  useEffect(() => {
    const loadSchoolId = async () => {
      try {
        const school = await getSchoolId();
        if (school !== null && school !== undefined) {
          setSchoolId(school);
        }
      } catch (error) {
        console.error("Error loading school ID", error);
      }
    };
    loadSchoolId();
  }, []);



  useEffect(() => {
    if (schoolId) {
      const fetchSchoolData = async () => {
        try {
          const response = await axios.get(
            `${baseUrl}/api/SchoolGeneralInfo/GetSchoolInfo?schoolId=${schoolId}`
          );
          if (response && response.data) {
            setSchoolData(response.data);
          }
        } catch (error) {
          console.log(
            "Failed to fetch student details. Please try again.",
            error
          );
        }
      };
      fetchSchoolData();
    }
  }, [schoolId]);

  if (!studentDetails) {
    return null; // Show nothing if student details are not yet loaded
  }


  const toBase64Image = async (url) => {
    if (!url) return null;

    try {
      const response = await fetch(url, {
        mode: "cors", // allow CORS
        cache: "no-cache",
      });

      if (!response.ok) {
        console.error("Image fetch failed:", response.statusText);
        return null;
      }

      const blob = await response.blob();

      return await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } catch (err) {
      console.error("Image toBase64 fetch error:", err.message);
      return null;
    }
  };

  const openPdfPreview = () => {
    const popup = window.open('', '_blank', 'width=900,height=800');
    if (!popup) return alert("Popup blocked. Please allow popups for this site.");

    const safe = (val) => (val ?? "N/A");
    const safeBool = (val) => val === true ? "Yes" : val === false ? "No" : "N/A";
    const safeDate = (val) => val ? formatDateToDDMMYYYY(val) : "N/A";
    const now = new Date();

    const htmlContent = `
  <html>
    <head>
      <title>Student Registration Form</title>
      <style>
        body {
          font-family: Montserrat-Arabic;
          font-size: 4px;
          margin: 0;
          padding: 0;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 10px;
        }
        td, th {
          border: 1px solid #000;
          padding: 6px;
          vertical-align: top;
          font-size: 10px;        
        }
        .center {
          text-align: center;
        }
        .photo-box {
          width: 100px;
          height: 100px;
          border: 1px solid #000;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .no-border {
          border: none;
        }
      </style>
    </head>
    <body>
      <table>
        <!-- Header -->
        <tr>
          <td style="width: 200px; height: 150px; text-align: center; vertical-align: middle;">
            ${schoolData.logo
        ? `<img src="${schoolData.logo}" alt="School Logo" style="max-width: 100%; max-height: 80%; object-fit: contain; display: block; margin: auto; border: 1px solid #000;" />`
        : `<div class="photo-box">No Logo</div>`}
          </td>
          <td colspan="2" class="center" style="padding: 10px; text-align:center; vertical-align:middle;">
            <b style="font-size: 18px;">${safe(schoolData.organizationName)}</b><br/>
            <b style="font-size: 18px; font-weight: bold;">${safe(schoolData.schoolOrCollegeName)}</b><br/>          
          </td>
          <td style="width: 120px; height: 140px; text-align: center; vertical-align: middle;">
            ${photoBase64
        ? `<img src="${photoBase64}" alt="Student Photo" style="max-width: 100%; max-height: 80%; object-fit: contain; display: block; margin: auto; border: 1px solid #000;" />`
        : `<div class="photo-box">No Photo</div>`}
          </td>
        </tr>
  
        <!-- Title -->
        <tr>
          <td colspan="4" class="center"><b>Admission Form Details for the Academic Year ${safe(studentDetails.sessionName)}</b><br>
          For Verification (For office use only) <br><br>
          <b style="text-transform: uppercase;">
          ${safe(studentDetails.standardName)} – ${safe(studentDetails.stream)} - ${safe(studentDetails.subjectGroupName)} (${safe(studentDetails.studentType)}) - (${safe(studentDetails.grantTypeName)}) 
          </b>
          <br>
          </td>
        </tr>
         <tr>
          <td colspan="2"><b>Admission Date:</b> </td>
          <td><b>GR No:</b> </td>
          <td><b>Roll No:</b> </td>
        </tr>
        <!-- Admission Details -->
        <tr><td colspan="4"><b>Admission Details</b></td></tr>
        <tr>
          <td><b>Section:</b> ${safe(studentDetails.section)}</td>
          <td colspan="3"><b>Subjects:</b> ${safe(studentDetails.subjectNames)}</td>
        </tr>
  
        <!-- Personal Details -->
        <tr><td colspan="4"><b>Student Personal Details</b></td></tr>
        <tr>
          <td><b>Full Name:</b> ${safe(studentDetails?.firstName?.toUpperCase())} ${safe(studentDetails?.middleName?.toUpperCase() ?? "")} ${safe(studentDetails?.lastName?.toUpperCase())}</td>
          <td><b>Gender:</b> ${safe(studentDetails.gender)}</td>
          <td><b>DOB:</b> ${safeDate(studentDetails.dateOfBirth)}</td>
          <td><b>Religion:</b> ${safe(studentDetails.religion)}</td>
        </tr>
        <tr>
          <td><b>Caste:</b> ${safe(studentDetails.caste)}</td>
          <td><b>Category:</b> ${safe(studentDetails.category)}</td>
           <td><b>Mother Tongue:</b> ${safe(studentDetails.motherTongue)}</td>
          <td><b>Birth Place:</b> ${safe(studentDetails.birthPlace)}</td>
        </tr>
        <tr>
          <td><b>Blood Group:</b> ${safe(studentDetails.bloodGroup)}</td>
          <td><b>Height (ft - cm):</b> ${studentDetails.heightInCm ? (studentDetails.heightInCm / 30.48).toFixed(2) + " - " + studentDetails.heightInCm : "N/A"}</td>
          <td><b>Weight (kg):</b> ${studentDetails.weightInKg ?? "N/A"}</td>
          <td><b>Aadhaar No:</b> ${safe(studentDetails.uidNo)}</td>
        </tr>
        <tr>
         <td><b>Name As Per Aadhaar:</b> ${studentDetails.nameAsPerAadhaar}</td>       
          <td><b>Disability:</b> ${safeBool(studentDetails.disability)}</td>
          <td colspan="2"><b>Disability Type & %:</b> ${safe(studentDetails.disabilityType)} / ${safe(studentDetails.disabilityPercentage)}</td>
        </tr>
  
        <!-- Contact Details -->
        <tr><td colspan="4"><b>Student Contact Details</b></td></tr>
        <tr>
          <td><b>Student Contact Number:</b> ${safe(studentDetails.studentContactNumber)}</td>
          <td><b>State:</b> ${safe(studentDetails.state)}</td>
           <td><b>District:</b> ${safe(studentDetails.district)}</td>
          <td><b>Taluka:</b> ${safe(studentDetails.taluka)}</td>
        </tr>
        <tr>
          <td><b>City/Village:</b> ${safe(studentDetails.cityVillage)}</td>      
          <td><b>Address:</b> ${safe(studentDetails.address)}</td>
          <td><b>Pincode:</b> ${safe(studentDetails.pincode)}</td>
          <td><b>Email ID :</b> ${safe(studentDetails.studentEmail)}</td>
        </tr>
  
        <!-- Parent Details -->
        <tr><td colspan="4"><b>Parent Details</b></td></tr>
        <tr>
          <td><b>Father Name:</b> ${safe(studentDetails.fatherFullName)}</td>
          <td><b>Contact Number:</b> ${safe(studentDetails.parentContactNumber)}</td>
          <td><b>Email ID :</b> ${safe(studentDetails.parentEmail)}</td>
           <td><b>Aadhaar No:</b> ${safe(studentDetails.parentAadhaarNo)}</td>
        </tr>
        <tr>
          <td><b>Occupation:</b> ${safe(studentDetails.parentOccupation)}</td>
          <td colspan="3"><b>Highest Qualification:</b> ${safe(studentDetails.parentHighestQualification)}</td>       
        </tr>
        <tr colspan="4"></tr>
        <tr>
          <td><b>Mother Name:</b> ${safe(studentDetails.motherFullName)}</td>
          <td><b>Contact Number:</b> ${safe(studentDetails.motherContactNumber)}</td>
          <td><b>Email ID :</b> ${safe(studentDetails.motherEmail)}</td>
          <td><b>Aadhaar No:</b> ${safe(studentDetails.motherAadhaarNo)}</td>
        </tr>
        <tr>
          <td><b>Occupation:</b> ${safe(studentDetails.motherOccupation)}</td>
          <td colspan="3"><b>Highest Qualification:</b> ${safe(studentDetails.motherHighestQualification)}</td>
        </tr>

        <tr><td colspan="4"><b>Guardian Details</b></td></tr>
        <tr>
          <td><b>Name:</b> ${safe(studentDetails.guardianFullName)}</td>
          <td><b>Contact Number:</b> ${safe(studentDetails.guardianContactNumber)}</td>
          <td><b>Email ID :</b> ${safe(studentDetails.guardianEmail)}</td>
          <td><b>Aadhaar No:</b> ${safe(studentDetails.guardianAadhaarNo)}</td>
        </tr>
        <tr>
          <td><b>Occupation:</b> ${safe(studentDetails.guardianOccupation)}</td>
          <td colspan="3"><b>Highest Qualification:</b> ${safe(studentDetails.guardianHighestQualification)}</td>
        </tr>      
  
        <!-- Previous School -->
        <tr><td colspan="4"><b>Previous School Details</b></td></tr>
        <tr>
          <td><b>UDISE No:</b> ${safe(studentDetails.udiseNo)}</td>
          <td><b>Standard-Stream:</b> ${safe(studentDetails.previousStandard)} - ${safe(studentDetails.previousStream)}</td>        
          <td><b>School Name:</b> ${safe(studentDetails.previousSchoolName)}</td>
          <td><b>Board:</b> ${safe(studentDetails.board)}</td>
        </tr>
        <tr>
          <td><b>Previous Standard %:</b> ${safe(studentDetails.previousStandardPercentage)}</td>
         <td><b>No. of Days Attended:</b> ${safe(studentDetails.previousAttendancePercentage)}</td>
         <td><b>Student SARAL ID:</b> ${safe(studentDetails.studentSaralId)}</td>
        <td><b>PEN No:</b> ${safe(studentDetails.permanentEducationNumber)}</td>
        </tr>     
        <tr>
          <td><b>APAAR ID:</b> ${safe(studentDetails.apaarId)}</td>
          <td colspan="3"><b>Exam Seat No:</b> ${safe(studentDetails.examSeatNo)}</td>
        </tr>
  
        <!-- Declaration -->
        <tr><td colspan="4"><b>Declaration</b></td></tr>
        <tr>
          <td colspan="4"  style="text-align:justify;">
            I hereby declare that the above information is true and correct to the best of my knowledge. I have carefully read
            and understood the rules and regulations of my higher secondary school and accept them. I also agree to abide
            by the rules and regulations of the college administration. I understand that the decision of the Principal is final
            and binding. I acknowledge that any inaccuracies or discrepancies in the provided information are my sole
            responsibility, and I will be held accountable for any consequences arising thereof.
          </td>
        </tr>
  
        <!-- Signatures -->
        <tr>
         <td colspan="2"  style="text-align:center; height:50px; vertical-align:bottom"><b>Student Signature</b></td>
        <td colspan="2" style="text-align:center; height:50px; vertical-align:bottom" class="center"><b>Checked By</b></td>
        </tr>
        <tr>
          <td colspan="2" style="text-align:center; height:50px; vertical-align:bottom" class="center"><b>Parent Signature</b></td>
          <td colspan="2" style="text-align:center; height:50px; vertical-align:bottom" class="center"><b>Principal Signature</b></td>
        </tr>
        <tr>
          <td colspan="4" style="text-align:left" class="center"> 
          
          <b>Date & Time :
    ${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()}
    ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}
  </b>
          </td>
        </tr>
      </table>   
      <script>
        setTimeout(() => window.print(), 1000);
      </script>
    </body>
  </html>
  `;


    popup.document.write(htmlContent);
    popup.document.close();
  };


  return (
    <>
      <Modal
        show={show}
        onHide={handleDetailsClose}
        dialogClassName="custom-modal-lg"
        centered
      >
        <Modal.Body>
          <div >
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td colSpan={8} class="text-start fw-bold text-white" style={{ backgroundColor: "black" }}>
                    <h4>Students Personal Details</h4></td>
                </tr>
                <tr>
                  <th>First Name</th>
                  <td>{studentDetails?.firstName?.toUpperCase()}</td>
                  <th>Middle Name</th>
                  <td>{studentDetails.middleName?.toUpperCase()}</td>
                  <th>Last Name</th>
                  <td>{studentDetails?.lastName?.toUpperCase()}</td>
                  <th>Gender</th>
                  <td>{studentDetails?.gender}</td>
                </tr>
                <tr>
                  <th>Date of Birth</th>
                  <td>{formatDateToDDMMYYYY(studentDetails.dateOfBirth)}</td>
                  <th>Date of Birth (Words)</th>
                  <td>{studentDetails.dateOfBirthInWords}</td>
                  <th>Religion</th>
                  <td>{studentDetails.religion}</td>
                  <th>Category</th>
                  <td>{studentDetails.category}</td>
                </tr>
                <tr>
                  <th>Caste</th>
                  <td>{studentDetails.caste}</td>
                  <th>Mother Tongue</th>
                  <td>{studentDetails.motherTongue}</td>
                  <th>Birth Place</th>
                  <td>{studentDetails.birthPlace}</td>
                  <th>Blood Group</th>
                  <td>{studentDetails.bloodGroup}</td>
                </tr>
                <tr>
                  <th>Height (ft - cm)</th>
                  <td>{(studentDetails.heightInCm / 30.48).toFixed(2)} - {studentDetails.heightInCm}</td>
                  <th>Weight (kg)</th>
                  <td>{studentDetails.weightInKg}</td>
                  <th>UID No</th>
                  <td>{studentDetails.uidNo}</td>
                  <th>Name As Per Aadhaar</th>
                  <td>{studentDetails.nameAsPerAadhaar}</td>
                </tr>

                <tr>
                  <th>EWS</th>
                  <td>{studentDetails.ews ? "Yes" : "No"}</td>
                  <th>Disability</th>
                  <td>{studentDetails.disability ? "Yes" : "No"}</td>
                  <th>Disability Type</th>
                  <td>{studentDetails.disabilityType ? studentDetails.disabilityType : "N/A"}</td>
                  <th>Disability %</th>
                  <td>{studentDetails.disabilityPercentage ? studentDetails.disabilityPercentage : "N/A"}</td>

                </tr>
                <tr>
                  <td colSpan={8} class="text-start fw-bold text-white" style={{ backgroundColor: "black" }}><h4>Contact Details</h4></td>
                </tr>
                <tr>
                  <th>Student PhoneNo</th>
                  <td>{studentDetails.studentContactNumber}</td>
                  <th>State</th>
                  <td>{studentDetails.state}</td>
                  <th>District</th>
                  <td>{studentDetails.district}</td>
                  <th>Taluka</th>
                  <td>{studentDetails.taluka}</td>
                </tr>
                <tr>
                  <th>City/Village</th>
                  <td>{studentDetails.cityVillage}</td>
                  <th>Address</th>
                  <td>{studentDetails.address}</td>
                  <th>Pincode</th>
                  <td>{studentDetails.pincode}</td>
                  <th>Email</th>
                  <td>{studentDetails.studentEmail}</td>
                </tr>
              </tbody>
            </table>
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td colSpan={12} class="text-start fw-bold text-white" style={{ backgroundColor: "black" }}><h4>Parent Details</h4></td>
                </tr>
                <tr>
                  <th>Father Name</th>
                  <td>{studentDetails.fatherFullName}</td>
                  <th>Phone No</th>
                  <td>{studentDetails.parentContactNumber}</td>
                  <th style={{ width: "100px" }}>Email</th>
                  <td>{studentDetails.parentEmail}</td>
                  <th>Occupation</th>
                  <td>{studentDetails.parentOccupation}</td>
                  <th>Highest Qualification</th>
                  <td>{studentDetails.parentHighestQualification}</td>
                  <td className="no">Aadhaar No - {studentDetails.parentAadhaarNo}</td>
                  <td className="no">Annual Income -{studentDetails.parentAnnualIncome}</td>
                </tr>
                <tr>
                  <th>Mother Name</th>
                  <td>{studentDetails.motherFullName}</td>
                  <th>Phone No</th>
                  <td>{studentDetails.motherContactNumber}</td>
                  <th style={{ width: "100px" }}>Email</th>
                  <td>{studentDetails.motherEmail}</td>
                  <th>Occupation</th>
                  <td>{studentDetails.motherOccupation}</td>
                  <th>Highest Qualification</th>
                  <td>{studentDetails.motherHighestQualification}</td>                  
                  <td className="no">Aadhaar No - {studentDetails.motherAadhaarNo}</td>                  
                  <td className="no">Annual Income - {studentDetails.motherAnnualIncome}</td>                </tr>
              </tbody>
            </table>
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td colSpan={12} class="text-start fw-bold text-white" style={{ backgroundColor: "black" }}><h4>Guardian Details</h4></td>
                </tr>
                <tr>
                  <th>Name</th>
                  <td>{studentDetails.guardianFullName}</td>
                  <th>Phone No</th>
                  <td>{studentDetails.guardianContactNumber}</td>
                  <th style={{ width: "100px" }}>Email</th>
                  <td>{studentDetails.guardianEmail}</td>
                  <th>Occupation</th>
                  <td>{studentDetails.guardianOccupation}</td>
                  <th>Highest Qualification</th>
                  <td>{studentDetails.guardianHighestQualification}</td>                  
                  <td className="no">Aadhaar No - {studentDetails.guardianAadhaarNo}</td>                  
                  <td className="no">Annual Income - {studentDetails.guardianAnnualIncome}</td>
                </tr>
              </tbody>
            </table>

            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td colSpan={10} class="text-start fw-bold text-white" style={{ backgroundColor: "black" }}><h4>Admission details</h4></td>
                </tr>
                <tr>
                  <th>Student Type</th>
                  <td>{studentDetails.studentType}</td>
                  <th>Admission Date</th>
                  <td>{formatDateToDDMMYYYY(studentDetails.admissionDate)}</td>
                  <th>Grant Type - {studentDetails.grantTypeName}</th>
                  <th>Medium - {studentDetails.mediumName}</th>
                  <th>Standard Name - {studentDetails.standardName}</th>
                  {/* <td>{studentDetails.standardName}</td> */}
                  <th>Section - {studentDetails.section}</th>
                  {/* <td>{studentDetails.section}</td> */}
                  <th>Stream</th>
                  <td>{studentDetails.stream}</td>
                </tr>
                <tr>
                  <th>Subjects</th>
                  <td>{studentDetails.subjectNames}</td>
                  <th>GR No</th>
                  <td>{studentDetails.generalRegisterNo}</td>
                  <th>Roll No</th>
                  <td>{studentDetails.rollNo}</td>
                  <th>Source of Admission</th>
                  <td>{studentDetails.sourceOfAdmission}</td>
                  <th>Subject Group</th>
                  <td>{studentDetails.subjectGroupName}</td>
                </tr>
              </tbody>
            </table>

            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td colSpan={8} class="text-start fw-bold text-white" style={{ backgroundColor: "black" }}><h4>Previous School Details</h4></td>
                </tr>
                <tr>
                  <th>UDISE No</th>
                  <td>{studentDetails.udiseNo}</td>
                  <th>Previous School</th>
                  <td>{studentDetails.previousSchoolName}</td>
                  <th>Previous Standard - Stream</th>
                  <td>{studentDetails.previousStandard} - {studentDetails.previousStream}</td>
                  <th>Previous Standard %</th>
                  <td>{studentDetails.previousStandardPercentage}</td>

                </tr>
                <tr>
                  <th>No. of Days School Attended</th>
                  <td>{studentDetails.previousAttendancePercentage}</td>
                  <th>Saral ID</th>
                  <td>{studentDetails.studentSaralId}</td>

                  <th>PEN No</th>
                  <td>{studentDetails.permanentEducationNumber}</td>
                  <th>Board</th>
                  <td>{studentDetails.board}</td>
                  {/* <th>School Name</th>
                  <td>{studentDetails.schoolName}</td> */}
                </tr>

                <tr>
                  <th>APAAR ID</th>
                  <td>{studentDetails.apaarId}</td>
                  <th>Session</th>
                  <td>{studentDetails.sessionName}</td>


                  <th>Early Release & Date</th>
                  <td>{studentDetails.earlyRelease ? "Yes" : "No"} - {studentDetails.earlyRelease ? formatDateToDDMMYYYY(studentDetails.earlyReleaseDate) : "N/A"}</td>
                  <th>Exam Seat No</th>
                  <td>{studentDetails.examSeatNo ? studentDetails.examSeatNo : "N/A"}</td>
                </tr>
                <tr>
                  <th>Distance Of Student Residence</th>
                  <td>{studentDetails.distanceOfStudentResidence}</td>
                </tr>

                <tr>
                  <td style={{ display: "none" }}>
                    <b className="mr-4"> Signature</b>
                    {studentDetails.sign ? (
                      <Link
                        to={studentDetails.sign}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={studentDetails.sign}
                          alt="Student sign"
                          style={{ width: "100px", height: "100px" }}
                        />
                      </Link>
                    ) : (
                      "Not Uploaded"
                    )}
                  </td>
                  <th style={{ display: "none" }}>Uploaded Document</th>
                  <td style={{ display: "none" }}>
                    {studentDetails.uploadedDocument ? (
                      <Link
                        to={studentDetails.uploadedDocument}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Download
                      </Link>
                    ) : (
                      "Not Uploaded"
                    )}
                  </td>
                  <th style={{ display: "none" }}><b className="mr-4">Photo</b></th>
                  <td style={{ display: "none" }}>

                    {studentDetails.photo ? (
                      <Link
                        to={studentDetails.photo}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={studentDetails.photo}
                          alt="Student Photo"
                          style={{ width: "100px", height: "100px" }}
                        />
                      </Link>
                    ) : (
                      "Not Uploaded"
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={openPdfPreview}>Preview & Print PDF</Button>
          <Button variant="secondary" onClick={handleDetailsClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default StudentDetailsModal;
